import React from "react";
import { motion } from "framer-motion";

const Drag = () => {
  return (
    <div>
      <h4>Drag</h4>
      <motion.div className="drag-frame">
        <motion.div
          style={{ backgroundColor: "#00C9A7" }}
          className="box"
          drag
          dragConstraints={{
            left: -50,
            right: 50,
            top: -50,
            bottom: 50,
          }}
          dragElastic={0.8}
          dragTransition={{ bounceStiffness: 900, bounceDamping: 15 }}
        ></motion.div>
      </motion.div>
    </div>
  );
};

export default Drag;
